import { useLocation } from "react-router-dom";

export const useActive = () => {
  const location = useLocation();
  const isActive = (path) => {
    if (!path) return false;
    return path.includes(location.pathname);
  };
  return {
    isActive,
  };
};
